export type EvseStatus = 'AVAILABLE' | 'OCCUPIED' | 'FAULTED' | 'UNAVAILABLE' | 'RESERVED' | string;

export type ConnectorStatusUI = 'available' | 'occupied' | 'out_of_order' | 'maintenance' | 'preparing';

export interface LocationStatusItem {
  locationId: string;
  isOnline: boolean;
  isAvailable: boolean;
  onlineChargePoints: number;
  totalChargePoints: number;
  availableEvses: number;
  totalEvses: number;
}

export interface LocationStatusResponse {
  locations: LocationStatusItem[];
  timestamp: string;
}

export interface ChargePointEvseStatus {
  evseId: string;
  connectorId: string;
  status: string;
  source: 'live' | 'master';
  currentSoc?: number | null;
}

export interface ChargePointStatusResponse {
  chargePointId: string;
  isOnline: boolean;
  evses: ChargePointEvseStatus[];
  timestamp: string;
}

export interface LiveTransactionStatus {
  id: string;
  status: string;
  chargePointId: string;
  connectorId: string;
  meterStart: number;
  totalKwh: number;
  currentPowerKw: number;
  currentSoc: number;
  totalCost: number;
  startedAt: string;
  lastMeterValueAt: string;
  stoppedAt: string | null;
  timestamp: string;
}

export function mapEvseStatusToUI(status: EvseStatus | string): ConnectorStatusUI {
  const normalizedStatus = status.toUpperCase();
  switch (normalizedStatus) {
    case 'AVAILABLE':
      return 'available';
    case 'OCCUPIED':
    case 'CHARGING':
    case 'FINISHING':
    case 'SUSPENDED_EVSE':
    case 'SUSPENDED_EV':
      return 'occupied';
    case 'PREPARING':
    case 'RESERVED':
      return 'preparing';
    case 'FAULTED':
    case 'UNAVAILABLE':
      return 'out_of_order';
    default:
      return status.toLowerCase() as ConnectorStatusUI;
  }
}
